/**************************************************
 * Nombre:       Tarjeta_Deposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import {theme} from "../../Tema";
import {QuestionMark, WalletOutlined} from '@mui/icons-material'
import {obtenerTotalRendimientos} from "../../CodigoCliente/Rendimientos/obtenerTotalRendimientos";
import {usuarioContext} from "../../App";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";
import RelojJueves from "./Componentes/RelojJueves";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Retiro_Rendimientos from "../Dialogos/Dialogo_Retiro_Rendimientos";


const Tarjeta_Rendimientos = () => {
    const cData = useContext(usuarioContext)
    const [totalRendimiento, setTotalRendimiento] = useState(0)
    const [activo, setActivo] = useState(false)
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Retiro_Rendimientos, titulo: 'Retiro de Rendimientos'})

    useEffect(() => {
        obtenerTotalRendimientos(cData.usuario.id).then((dox) => {
            setTotalRendimiento(dox)
        })

    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#fff',
                borderRadius: 1,
                p: 2,
                color: '#011237',
                minHeight: 170
            }}
        >

            <Dialogo/>

            <Grid container size={{xs: 9, sm: 9, md: 9}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',}}>
                        <Typography sx={{fontSize: 16, fontWeight: 400}}>Rendimientos Actuales</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 24, fontWeight: 600, color: theme.palette.primary.main}}>
                            {`${formatoMonedaTabla(totalRendimiento, 2)} USD`}
                        </Typography>
                    </Grid>

                </Grid>
            </Grid>


            <Grid container size={{xs: 3, sm: 3, md: 3}}
                  sx={{justifyContent: 'flex-end', mt: 0, color: '#000'}}>
                <IconButton sx={{backgroundColor: '#D9D9D9', width: 32, height: 32}}>
                    <QuestionMark/>
                </IconButton>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-end'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 14, fontWeight: 300}}>Retiro mínimo 30 USD</Typography>
                    </Grid>

                    <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                        <Grid
                            container
                            justifyContent={'flex-end'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                                <RelojJueves setActivo={setActivo}/>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'flex-start', mt: 1}}>
                                <Button
                                    onClick={() => abrir()}
                                    disabled={activo || cData.usuario.retiroRendimientos === 'No'}
                                    fullWidth
                                    startIcon={<WalletOutlined/>}
                                    sx={{backgroundColor: '#011237'}}
                                > Retiro</Button>
                            </Grid>

                        </Grid>
                    </Grid>

                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Rendimientos
